// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3-eAK","file":"styles_file__1Oetw"};